<div class="payment-confirmation">
    <div class="payment-confirmation__header">
      <h1 class="title">Payment time-out</h1>
    </div>
    <div class="payment-confirmation__message">
        <span>Your payment hasn't been registered.</span>
    </div>
</div>
